<template>
  <div class="translate-wrapper">
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <div class="poster-title">
          Banner Image (3840х960)
        </div>
        <PosterImage
          ref="posterImage"
          :key="formData.posterImages"
          :poster="formData.posterImages"
          :is4kPoster="true"
          :onPosterChange="handlePosterChange"
          :isNeedRemove="true"
        />
        <div
          v-if="isThemeBasic"
          class="banner-wrapper"
        >
          <div class="poster-title">
            Banner Mobile Image (2880x960)
          </div>
          <PosterImage
            ref="posterImage"
            :key="formData.mobileBannerImage"
            :poster="formData.mobileBannerImage"
            :is4kMobileBannerImage="true"
            :onPosterChange="handleMobileBannerImageChange"
            :isNeedRemove="true"
          />
        </div>
        <div class="btn-wrapper">
          <div class="btn-wrapper-b">
            <Button
              type="submit"
              :title="'Apply Changes'"
              :classType="'primary'"
            />
            <Button
              :title="'Revert'"
              :classType="'warning'"
              :eventFunction="revertLanguage"
            />
          </div>
          <div
            v-if="isEditedForm.length
              && isEditedForm.find(item => item.id === lang.id && !!item.value)"
            class="changes-wrapper"
          >
            <inline-svg
              :src="iconChanges"
              class="svg-icon"
            >
            </inline-svg>
            <span class="changes-text">
              Unsaved changes
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseForm from '../BaseForm.vue';
import Button from '../../common/Button.vue';
import iconChanges from '../../../assets/icons/icon-localization-changes.svg';
import PosterImage from '../../common/PosterImage/DragAndDropFileUploader.vue';

import {
  ADD_LANGUAGE_BANNERS_REQUEST,
  GET_LANGUAGE_BANNERS_REQUEST,
  INIT_FORM_CHANGES,
  SET_FORM_CHANGES,
} from '../../../store/actions/localization/localizationActions';

export default {
  name: 'BannerV1LocalizationForm',
  components: {
    PosterImage,
    Button,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'cmsManuallyLocalization',
    },
    lang: {
      type: Object,
      default: () => {},
    },
    banner: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    changedLanguage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      iconChanges,
      submitEvent: ADD_LANGUAGE_BANNERS_REQUEST,
      successMessages: `The ${this.lang.name} Localization has been successfully updated`,
      isPosterSmallChanged: false,
      isMobileBannerImageChanged: false,
      formData: {
        posterImages: '',
        mobileBannerImage: '',
      },
      formFields: {
        label: {
          type: 'text',
          name: 'label',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
            max: 25,
          },
        },
      },
      errorMapping: {
        label: [
          `${this.formPrefix}.label`,
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isEditedForm: (state) => state.localization.isEditedForm,
      bannerLanguage: (state) => state.localization.bannerLanguage,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'isThemeBasic',
    ]),
  },
  created() {
    const value = this.languages.map(((item) => ({
      id: item.id,
      value: false,
    })));
    this.$store.dispatch(INIT_FORM_CHANGES, value);

    const params = {
      accountId: this.getCurrentAccountId,
      bannerId: this.banner && this.banner.id,
      langId: this.lang.id,
    };
    this.$store.dispatch(GET_LANGUAGE_BANNERS_REQUEST, params).then((res) => {
      this.initFormData(res);
    });
  },
  beforeDestroy() {
    this.$store.dispatch(SET_FORM_CHANGES, []);
  },
  methods: {
    handleFormChange() {
      this.$emit('changedLanguage', { id: this.lang.id, value: true });
    },
    handlePosterChange(img) {
      this.isPosterSmallChanged = true;
      this.handleFormChange();
      this.formData.posterImages = img;
    },
    handleMobileBannerImageChange(img) {
      this.isMobileBannerImageChanged = true;
      this.handleFormChange();
      this.formData.mobileBannerImage = img;
    },
    initFormData(data) {
      this.formData.posterImages = data.bannerImage
        ? `${data.bannerImage}?height=360`
        : '';

      if (this.isThemeBasic) {
        this.formData.mobileBannerImage = data.mobileBannerImage
          ? `${data.mobileBannerImage}?height=360`
          : '';
      }
    },
    revertLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        bannerId: this.banner && this.banner.id,
        langId: this.lang.id,
      };
      this.$store.dispatch(GET_LANGUAGE_BANNERS_REQUEST, params).then((res) => {
        this.$emit('changedLanguage', { id: this.lang.id, value: false });
        this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
        this.isPosterSmallChanged = false;
        this.isMobileBannerImageChanged = false;
        this.initFormData(res);
      });
    },
    getRequestData() {
      const data = {
        bannerImage: this.formData.posterImages,
      };

      if (!this.isPosterSmallChanged) {
        delete data.bannerImage;
      }

      if (this.isThemeBasic && this.isMobileBannerImageChanged) {
        data.mobileBannerImage = this.formData.mobileBannerImage;
      }

      return {
        accountId: this.getCurrentAccountId,
        bannerId: this.banner && this.banner.id,
        langId: this.lang.id,
        data,
      };
    },
    onSubmitSuccess() {
      this.isPosterSmallChanged = false;
      this.isMobileBannerImageChanged = false;
      this.$emit('changedLanguage', { id: this.lang.id, value: false });
      this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
      this.$toasted.global.success({
        message: this.successMessages,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.translate-wrapper {
}

.poster-title {
  color: #fff;
  font-weight: normal;
  margin-bottom: 10px;
}

.btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 35px;
}

.changes-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #FB3951;
  border-radius: 2px;
  padding: 8px;
  color: #FB3951;
  margin-left: 20px;
}

.banner-wrapper {
  margin-top: 30px;
}

.changes-text {
  padding-left: 5px;
}

.btn-wrapper-b {
  display: flex;
}
</style>
